import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Header from '../../components/header/Header';
import Navbar from '../../components/navbar/Navbar';
import { getProductFilters, getApprovedProducts } from '../../redux/actions/ProductActions';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import Rating from '../../components/Rating';
import { Link } from 'react-router-dom';
import { BsListUl } from 'react-icons/bs';
import { MdOutlineSpaceDashboard } from 'react-icons/md';


const ProductFilterScreen = ({ getApprovedProducts, approvedProducts, getProductFilters, productFilter }) => {

    const [category, setCategory] = useState('')
    const [priceCategory, setPriceCategory] = useState('')
    const [productView, setProductView] = useState('row')
    const [categoryProduct, setCategoryProduct] = useState([])
    const [scrolled, setScrolled] = useState(false);


    const { loading, product_filter , error } = productFilter;
    
    const { loading:productLoading, products, error:productError } = approvedProducts;


    useEffect(() => {
        getApprovedProducts()
        getProductFilters()
    }, [getApprovedProducts, getProductFilters])


    useEffect(() => {

        window.addEventListener('scroll', handleScroll)
    })


    const categoryHandler = (e) => {

        setCategory(e.target.value)

        if (e.target.value === 'all') {
            setCategoryProduct(products)
        }else{
            const filter = products.filter((val) => val.category.toLowerCase() === e.target.value.toLowerCase())
            setCategoryProduct(filter);
        }
    }

    const priceCategoryHandler = (e) => {

        setPriceCategory(e.target.value)

        if (e.target.value === 'low_to_high') {

            if (categoryProduct.length > 0) {
                setCategoryProduct(categoryProduct?.sort((a, b) => a.price > b.price ? 1 : -1))
            }else{
                setCategoryProduct(products?.sort((a, b) => a.price > b.price ? 1 : -1))
            }

        } else if (e.target.value === 'high_to_low'){


            if (categoryProduct.length > 0) {
                setCategoryProduct(categoryProduct?.sort((a, b) => a.price < b.price ? 1 : -1))
            } else {
                setCategoryProduct(products?.sort((a, b) => a.price < b.price ? 1 : -1))
            }

        }else{

            setCategoryProduct(products);
        }
    }


    const productViewHandler = (style) => {

        setProductView(style)
    }


    const handleScroll = () => {

        const offset = window.pageYOffset;

        if (offset > 7) {
            setScrolled(true)
        } else {
            setScrolled(false)
        }
    }


    return (
        <>
            <Header />
            <Navbar />
            <div className='mt-28 container max-w-screen-xl mx-auto mb-16 px-4'>
                <div className='uppercase text-2xl my-6 text-black tracking-wider font-normal text-center'>Products</div>

                {
                    loading ? <Loader /> : error ? <Message error msg={error} /> : (
                        <div className='flex relative'>
                            <div className={scrolled ? 'fixed lg:w-64 top-28 left-24 p-2 lg:block hidden' : 'fixed lg:w-64 p-2 lg:block hidden' }>
                                
                                <div className='mb-5 font-medium text-md uppercase tracking-wide'>
                                    Total Products: <span className='text-[#ef233c]'>{products?.length}</span> 
                                </div>


                                <div className='flex mt-8'>
                                    <div onClick={() => productViewHandler('column')} className={productView === 'column' ? ' text-2xl shadow-md p-2 rounded-md mr-5 cursor-pointer text-green-400' : 'text-2xl shadow-md p-2 rounded-md mr-5 cursor-pointer  text-black'}>
                                        <BsListUl  />
                                    </div>
                                    <div onClick={() => productViewHandler('row')} className={productView === 'row' ? ' text-2xl shadow-md p-2 rounded-md mr-5 cursor-pointer text-green-400' : ' text-2xl shadow-md p-2 rounded-md mr-5 cursor-pointer text-black'}>
                                        <MdOutlineSpaceDashboard />
                                    </div>
                                </div>


                                <div className='mt-8'>
                                    <label htmlFor="category" className='sen-font text-md'>Product Category</label>
                                    <select
                                        onChange={categoryHandler}
                                        name="category"
                                        value={category}
                                        id='category'
                                        className='w-full mt-2 p-2 sen-font border border-gray-300 rounded-lg'
                                    >
                                        <option value="">Categories</option>
                                        <option value="all">all</option>
                                        {
                                            product_filter?.category?.map((val, index) => (
                                                <option value={val.label} key={index}>{val.label}</option>
                                            ))
                                        }
                                    </select>
                                </div>

                                <div className='mt-8'>
                                    <label htmlFor="price_category" className='sen-font text-md'>Price Category</label>
                                    <select
                                        onChange={priceCategoryHandler}
                                        name="price_category"
                                        value={priceCategory}
                                        id='price_category'
                                        className='w-full mt-2 p-2 sen-font border border-gray-300 rounded-lg'
                                    >
                                        <option value=''>Categories</option>
                                        <option value='low_to_high'>Low to High</option>
                                        <option value='high_to_low'>High to Low</option>
                                    </select>
                                </div>
                            </div>


                            <div className='w-full lg:ml-72 p-2'>

                                {
                                    productView === 'column' && (
                                        <>

                                            {
                                                productLoading ? <Loader /> : productError ? <Message error msg={productError} /> : (
                                                    <div className=''>
                                                        {
                                                            categoryProduct.length > 0 ?

                                                                <>
                                                                    {
                                                                        categoryProduct?.map((val) => (
                                                                            <div key={val._id} className=' my-3 bg-white shadow-md rounded-lg p-3'>
                                                                                <div className='grid grid-cols-2 gap-3 '>
                                                                                    <Link to={`/product/${val._id}`} className=''>
                                                                                        <img src={val.image} alt={val.name} className='w-full cursor-pointer object-cover h-60 rounded-t-lg' />
                                                                                    </Link>
                                                                                    <div className='p-4'>
                                                                                        <Link to={`/product/${val._id}`} className='hover:underline product__name cursor-pointer mont-font uppercase'>{val.name}</Link>
                                                                                        <Rating value={val.rating} text={`${val.numReviews} reviews`} />
                                                                                        <div className='font-semibold text-xl mt-3'>₹{val.price}</div>
                                                                                        <div className='product__desc font sen-font leading-6 mt-3 md:h-24 md:overflow-auto md:overscroll-auto'>{val.description}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </>
                                                                :

                                                                <>
                                                                    {
                                                                        products?.map((val) => (
                                                                            <div key={val._id} className=' my-3 bg-white shadow-md rounded-lg p-3'>
                                                                                <div className='grid grid-cols-2 gap-3 '>
                                                                                    <Link to={`/product/${val._id}`} className=''>
                                                                                        <img src={val.image} alt={val.name} className='w-full cursor-pointer object-cover h-60 rounded-t-lg' />
                                                                                    </Link>
                                                                                    <div className='p-4'>
                                                                                        <Link to={`/product/${val._id}`} className='hover:underline product__name cursor-pointer mont-font uppercase'>{val.name}</Link>
                                                                                        <Rating value={val.rating} text={`${val.numReviews} reviews`} />
                                                                                        <div className='font-semibold text-xl mt-3'>₹{val.price}</div>
                                                                                        <div className='product__desc font sen-font leading-6 mt-3 md:h-24 md:overflow-auto md:overscroll-auto'>{val.description}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </>

                                                        }
                                                    </div>
                                                )
                                            }
                                            
                                        </>
                                    ) 
                                }

                                {
                                    productView === 'row' && (
                                        <>
                                            {
                                                productLoading ? <Loader /> : productError ? <Message error msg={productError} /> : (
                                                    <div className=' grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 gap-y-7 my-5 '>
                                                        {
                                                            categoryProduct.length > 0 ?

                                                                <>
                                                                    {
                                                                        categoryProduct.map((val) => (
                                                                            <div key={val._id} >
                                                                                <div className='bg-white shadow-md rounded-lg hi'>
                                                                                    <Link to={`/product/${val._id}`}>
                                                                                        <img src={val.image} alt={val.name} className='w-full cursor-pointer object-cover h-60 rounded-t-lg' />
                                                                                    </Link>
                                                                                    <div className='p-4'>
                                                                                        <Link to={`/product/${val._id}`} className='hover:underline product__name cursor-pointer mont-font'>{val.name}</Link>
                                                                                        <Rating value={val.rating} text={`${val.numReviews} reviews`} />
                                                                                        <div className='font-semibold text-xl'>₹{val.price}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </>
                                                                :

                                                                <>
                                                                    {
                                                                        products?.map((val) => (
                                                                            <div key={val._id} >
                                                                                <div className='bg-white shadow-md rounded-lg hi'>
                                                                                    <Link to={`/product/${val._id}`}>
                                                                                        <img src={val.image} alt={val.name} className='w-full cursor-pointer object-cover h-60 rounded-t-lg' />
                                                                                    </Link>
                                                                                    <div className='p-4'>
                                                                                        <Link to={`/product/${val._id}`} className='hover:underline product__name cursor-pointer mont-font'>{val.name}</Link>
                                                                                        <Rating value={val.rating} text={`${val.numReviews} reviews`} />
                                                                                        <div className='font-semibold text-xl'>₹{val.price}</div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        ))
                                                                    }
                                                                </>

                                                        }
                                                    </div>
                                                )
                                            }
                                        </>
                                    )
                                }

                            </div>
                        </div>
                    )
                }
               
            </div>
        </>
    )
}



const mapStateToProps = (state) => ({
    productFilter: state.productFilter,
    approvedProducts: state.approvedProducts
})


export default connect(mapStateToProps, { getApprovedProducts, getProductFilters  })(ProductFilterScreen);